"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = exports.LoggerWrapper = void 0;
const loglevel_1 = __importDefault(require("loglevel"));
const logger_wrapper_1 = require("./logger-wrapper");
Object.defineProperty(exports, "LoggerWrapper", { enumerable: true, get: function () { return logger_wrapper_1.LoggerWrapper; } });
const file_strategy_1 = require("./strategies/file-strategy");
const dummy_logger_1 = require("./util/dummy-logger");
const detect_environment_1 = require("../util/detect-environment");
const types_1 = require("@refinitiv-data/types");
let logger;
/**
 * https://github.com/avajs/ava/blob/f72fab40160a413f4d7ab0208979fe3e721198ea/docs/01-writing-tests.md
 *
 * AVA will set process.env.NODE_ENV to test, unless the NODE_ENV environment variable has been set.
 */
if ((0, detect_environment_1.detectEnvironment)() !== types_1.Environment.WEB && process.env.NODE_ENV === 'test') {
    exports.logger = logger = dummy_logger_1.dummyLogger;
}
else {
    const wrapper = new logger_wrapper_1.LoggerWrapper(loglevel_1.default);
    wrapper.register(new file_strategy_1.FileStrategy());
    exports.logger = logger = wrapper.getWrappedLogger();
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbG9nZ2VyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLHdEQUF1RztBQUV2RyxxREFBaUQ7QUFRVSw4RkFSbEQsOEJBQWEsT0FRa0Q7QUFQeEUsOERBQTBEO0FBRTFELHNEQUFrRDtBQUNsRCxtRUFBK0Q7QUFDL0QsaURBQW9EO0FBS3BELElBQUksTUFBa0IsQ0FBQztBQUV2Qjs7OztHQUlHO0FBQ0gsSUFBSSxJQUFBLHNDQUFpQixHQUFFLEtBQUssbUJBQVcsQ0FBQyxHQUFHLElBQUksT0FBTyxDQUFDLEdBQUcsQ0FBQyxRQUFRLEtBQUssTUFBTSxFQUFFLENBQUM7SUFDN0UsaUJBQUEsTUFBTSxHQUFHLDBCQUFXLENBQUM7QUFDekIsQ0FBQztLQUFNLENBQUM7SUFDSixNQUFNLE9BQU8sR0FBRyxJQUFJLDhCQUFhLENBQUMsa0JBQVEsQ0FBQyxDQUFDO0lBQzVDLE9BQU8sQ0FBQyxRQUFRLENBQUMsSUFBSSw0QkFBWSxFQUFFLENBQUMsQ0FBQztJQUNyQyxpQkFBQSxNQUFNLEdBQUcsT0FBTyxDQUFDLGdCQUFnQixFQUFFLENBQUM7QUFDeEMsQ0FBQyJ9